const urlExp = /(https?:\/\/)?([\w-])+\.{1}([a-zA-Z]{2,63})([\\w-]*)*\/?\??([^#\n\r]*)?#?([^\n\r]*)/;
const freeMail = /^([A-Za-z0-9.!#$%&’*+/=?^_`{|}~-]+@(?!yahoo\.com)(?!hotmail\.com)(?!live\.com)(?!aol\.com)(?!msn\.com)(?!outlook\.com)(?!gmail\.com)(?!bellsouth\.net)(?!icloud\.com)([\w-]+.)+[\w-]{2,8})?$/i;
const regex = new RegExp(urlExp);

export const validate = (type, isRequired, marketoMessage, name, value) => {
  let errors = {};

  let message = marketoMessage.replace(`<span class='mktoErrorDetail'>`, '');
  message = message.replace('</span>', '');
  if (/^.*?(?=[\^#%&;$\*:<>/\{\|\}]).*$/gi.test(value)) {
    errors[name] = 'Invalid characters';
  } else if (isRequired && !value) {
    errors[name] = 'Required';
  } else if (type === 'email' && !freeMail.test(value)) {
    errors[name] = 'Must be a business email';
  } else if (type === 'email' && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,8}$/i.test(value)) {
    errors[name] = message;
  } else if (type === 'url' && !value.match(regex)) {
    errors[name] = message;
  } else if (type === 'number' && !/[0-9]/g.test(value)) {
    errors[name] = message;
  } else {
    return null;
  }
  return errors;
};
